export default __webpack_public_path__ + "static/media/SleeptestImage.621aea1b.jpg";